export default __webpack_public_path__ + "static/bubble-with-categories-b700067fa14862a659e26dbd4c3ee2f4.png";